import KunLoading60 from './src/index'

KunLoading60.install = function (Vue) {
	Vue.component(KunLoading60.name, KunLoading60);
}

export default KunLoading60;
